/* eslint-disable react/jsx-no-bind */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as artistAdminActions from '../../actions/artistAdminActions';
import * as instrumentActions from '../../actions/instrumentActions';
import * as genreActions from '../../actions/genreActions';
import LocationService from '../../services/locationService';
import roleTypes from '../../constants/roleTypes';
import AsyncTypeahead from 'react-bootstrap-typeahead/lib/AsyncTypeahead.react'; 
import 'react-bootstrap-typeahead/css/Typeahead.css';
import * as browserCheck from '../../utils/browserCheck.js';
import {expertises} from '../../constants/staticLists';
import pull from 'lodash/pull';
import ErrorMessage from '../common/ErrorMessage';
import * as textUtils from '../../utils/textUtils';
import MaterialInput from '../common/MaterialInput';
import MaterialDropDown from '../common/MaterialDropDown';
import { trimStart } from 'lodash';

class CreateProfileForm extends Component {
    constructor(props, context) {
        super(props, context);
        this.getDisplayName = this.getDisplayName.bind(this);
        this.clear = this.clear.bind(this);
        this.createUpdateProfile = this.createUpdateProfile.bind(this);            
        this.locationSearch = this.locationSearch.bind(this);
        this.locationSelected = this.locationSelected.bind(this);
        this.getGenreText = this.getGenreText.bind(this);
        this.updateGenre = this.updateGenre.bind(this);
        this.getLocationSelected = this.getLocationSelected.bind(this);
        this.state = {
            locationTypeaheadLoading: false,
            locationTypeaheadOptions: []
        };    
    }    

    componentWillMount() {
        this.props.actions.getInstruments();
        this.props.actions.getGenres();
    }

    componentDidMount() {
        $([this.usernameControlRef, this.facebookControlRef, this.websiteControlRef]).tooltip();
        if(browserCheck.canUseDom()) {                
            window.componentHandler.upgradeDom();      
            const {getmdlSelect} = require('../../scripts/getmdl-select.js');
            getmdlSelect.init('#frmCreateProfile .getmdl-select');    
            $('#RoleType').parent().addClass('is-dirty');   
        }
    }

    componentDidUpdate(prevProps) {
        if(this.props.currentProfile.RoleType !== prevProps.currentProfile.RoleType) {
            $([this.usernameControlRef, this.facebookControlRef, this.websiteControlRef]).tooltip();
            //we might have added new fields that need the material styling activated
            window.componentHandler.upgradeDom();      
            const {getmdlSelect} = require('../../scripts/getmdl-select.js');
            getmdlSelect.init('#frmCreateProfile .getmdl-select');    
        }
        if(this.props.currentProfile.Genres !== prevProps.currentProfile.Genres || this.props.genres !== prevProps.genres) {
            if(this.props.genres !== prevProps.genres) {
                //we've only just loaded the genres, upgrade the control
                window.componentHandler.upgradeDom();  
            }
            $('#divGenres.multidropdown .dropdown-menu ul li label').each((index, item) => {
                $(item).addClass('is-upgraded');
            });
        }
    }

    getDisplayName() {
        const roleType = this.props.currentProfile.RoleType;
        if(roleType == 'Artist'){
            return 'Artist/Band Name';
        }
        else if (roleType == 'RecordLabel'){
            return 'Label Name';
        }
        else if (roleType == 'RecordingStudio') {
            return 'Studio Name';
        }
        else if (roleType == 'Venue') {
            return 'Venue Name';
        }
        else {
            return 'Display Name';
        }
    }

    clear() {
        this.props.clear();
    }

    createUpdateProfile(event) {
        //do some validation
        event.preventDefault();
        if(!this.props.currentProfile.ID) {
            this.props.actions.createProfile(this.props.currentProfile)
                .then(profile => {
                    if(profile) {
                        this.clear();
                        if(this.props.onProfileCreated) {
                            //we don't need this parameter for now, but it seems sensible to send it
                            this.props.onProfileCreated(profile);
                        }
                    }
                });
        }
        else {
            this.props.actions.updateProfile(this.props.currentProfile.ID, this.props.currentProfile);
        }
    }

    locationSearch(query) {
        this.setState({locationTypeaheadLoading: true});
        LocationService.searchLocation('', true, true, query)
        .then(items => {
            this.setState({
                locationTypeaheadLoading: false,
                locationTypeaheadOptions: items
            });
        } );
    }

    locationSelected(items) {
        this.props.updateLocation(items);
        //this.props.actions.updateLocation(items);        
    }

    getLocationSelected() {
        //return the selected location in typeahead format
        const profile = this.props.currentProfile;
        const items = [];
        if(profile.City) {
            const label = profile.LocationDesc ? profile.LocationDesc : textUtils.formatLocation(profile.City, profile.Region, profile.Country);
            items.push({
                label: label,
                value: label,
                city: profile.City,
                region: profile.Region,
                country: profile.Country,
                longitude: profile.Longitude,
                latitude: profile.Latitude
            });
        }
        return items;
    }

    getGenreText() {
        if(!this.props.currentProfile.Genres || this.props.currentProfile.Genres.length == 0) {
            return 'Select up to 5 Genres';
        }
        else {
            const genreText = this.props.currentProfile.Genres.toString().replace(/,/g, ', ');
            return genreText;
        }
    }

    updateGenre(event) {        
        const value = event.target.value;
        const checked = event.target.checked;
        const genres = [...this.props.currentProfile.Genres];
        if(checked && genres.length < 5) {
            genres.push(value);
        }
        else {
            pull(genres, value);
        }
        this.props.updateProfileField({ target: { name: "Genres", value: genres }});
        if(genres.length < 5) {
            //clicking seems to hide the drop down so let's add it back if we're not adding the final item
            $('.multidropdown').addClass('open');
        }
    }

    render() {        
        return (
            <form id="frmCreateProfile" className="form form-tightfields form-regular" onSubmit={this.createUpdateProfile}>
                <ErrorMessage error={this.props.createProfileError} onClose={this.props.actions.clearCreateProfileError} />                 
                <div className="row">
                    <div className="col-sm-12">
                        <div id="formNarrow" className={this.props.displayNarrow ? 'form-narrow' : ''}>
                            <div className="row">
                                <div className="col-md-6">
                                    <MaterialDropDown 
                                        id="RoleType"
                                        name="RoleType" 
                                        className="getmdl-select__fullwidth" 
                                        value={this.props.currentProfile.RoleType} 
                                        showLabel
                                        label="Profile Type" 
                                        itemValueFunc={(r) => r.type}
                                        itemTextFunc={(r) => r.friendlyName}
                                        data={roleTypes.filter(r => r.public || (this.props.currentProfile.RoleType && this.props.currentProfile.RoleType === r.type))} 
                                        onClick={(e) => this.props.updateProfileField({target:{name: 'RoleType', value: e.target.innerText}})} 
                                        readOnly={this.props.currentProfile.ID} />                                        
                                </div>
                                <div className="col-md-6">
                                    <div id="divUsername" className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-block mdl-prefixed">
                                        <p className="prefix">loudup.com/</p>
                                        <input type="text" id="Username" name="Username" className="mdl-textfield__input focustip" value={this.props.currentProfile.Username} onChange={this.props.updateProfileField} ref={(control) => this.usernameControlRef = control} data-toggle="tooltip" data-placement="top" title = "This will form the url to your profile page e.g. https://www.loudup.com/username . It can only contain letters, numbers, dots, dashes, and underscores." />
                                        <label className="mdl-textfield__label" htmlFor="Username">User Name</label>
                                    </div>
                                </div>
                            </div>
                            {
                                this.props.currentProfile.RoleType === 'Musician' ?
                                    <div id="divMusicianInfo" className="form-group">
                                        <span style={{fontSize:'0.8em', fontStyle:'italic', color: '#e55d1e'}}>This profile type is for session musicians or users interested in joining a band</span>
                                    </div>
                                : null
                            }
                            {
                                this.props.currentProfile.RoleType === 'Songwriter' ?
                                    <div id="divSongwriterInfo" className="form-group">
                                        <span style={{fontSize:'0.8em', fontStyle:'italic', color: '#e55d1e'}}>If you write songs for other people, this profile type is for you. If you write and perform your own songs, please select Artist/Band as your profile type</span>
                                    </div>
                                : null
                            }
                            <MaterialInput name="DisplayName" value={this.props.currentProfile.DisplayName} onChange={this.props.updateProfileField} label={this.getDisplayName()} />
                            {
                                !this.props.currentProfile.ID ?
                                    <div id="divLocation" className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-block is-dirty">
                                        <AsyncTypeahead id="Location" placeholder="City Name" minLength={3} isLoading={this.state.locationTypeaheadLoading} onSearch={this.locationSearch} onChange={this.locationSelected} options={this.state.locationTypeaheadOptions} selected={this.getLocationSelected()} />
                                        <label className="mdl-textfield__label" htmlFor="Location">Location</label>
                                    </div>
                                    : null
                            }
                            {
                                this.props.currentProfile.RoleType === 'Venue' ?
                                    <MaterialInput type="number" name="Capacity" value={this.props.currentProfile.Capacity} onChange={this.props.updateProfileField} />
                                    : null
                            }
                            {
                                this.props.currentProfile.RoleType === 'Musician' ?
                                    <div className="row">
                                        <div className="col-md-6">
                                            <MaterialDropDown name="Instrument" className="getmdl-select__fullwidth getmdl-select--limited placeholder" value={this.props.currentProfile.Instrument} showLabel data={this.props.instruments} onClick={(e) => this.props.updateProfileField({target:{name: 'Instrument', value: e.target.innerText}})} />
                                        </div>
                                        <div className="col-md-6">
                                            <MaterialDropDown name="Expertise" className="getmdl-select__fullwidth getmdl-select--limited placeholder" value={this.props.currentProfile.Expertise} showLabel data={expertises} onClick={(e) => this.props.updateProfileField({target:{name: 'Expertise', value: e.target.innerText}})} />
                                        </div>
                                    </div>
                                : null
                            }
                            {
                                this.props.currentProfile.RoleType != 'Venue' && this.props.currentProfile.RoleType != 'RecordingStudio' ?
                                    <div id="divGenres" className="dropdown multidropdown withlabel fullwidth">
                                        <label className="smalllabel">Music Genres</label>
                                        <a href="#" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                                            <span className="selection">{this.getGenreText()}</span>
                                            <span className="caret" />
                                        </a>
                                        <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
                                            <ul className="list-unstyled">
                                                {
                                                    this.props.genres.map((genre, i) => 
                                                    {
                                                        const checked = this.props.currentProfile.Genres && this.props.currentProfile.Genres.includes(genre);
                                                        return <li key={genre}>
                                                            <label className={`mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect ${checked ? 'is-checked' : ''}`} htmlFor={`checkbox-${i}`}>
                                                                {checked ?
                                                                    <input type="checkbox" id={`checkbox-${i}`} className="mdl-checkbox__input" name="Genres" value={genre} onChange={this.updateGenre} checked />
                                                                    : <input type="checkbox" id={`checkbox-${i}`} className="mdl-checkbox__input" name="Genres" value={genre} onChange={this.updateGenre} disabled={this.props.currentProfile.Genres && this.props.currentProfile.Genres.length >= 5} />}
                                                                <span className="mdl-checkbox__label">{genre}</span>
                                                            </label>
                                                        </li>;
                                                    })
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                : null
                            }                            
                            <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-block mdl-prefixed">
                                <p className="prefix">@</p>
                                <input type="text" id="TwitterUsername" name="TwitterUsername" className="mdl-textfield__input" value={this.props.currentProfile.TwitterUsername ? trimStart(this.props.currentProfile.TwitterUsername, '@') : this.props.currentProfile.TwitterUsername} onChange={this.props.updateProfileField} />
                                <label className="mdl-textfield__label" htmlFor="TwitterUsername">Twitter Username</label>
                            </div>
                            {
                                this.props.currentProfile.RoleType !== 'Fan' ?
                                    <React.Fragment>
                                        <div id="divFacebookUsername" className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-block mdl-prefixed">
                                            <p className="prefix">facebook.com/</p>
                                            <input type="text" id="FacebookUsername" name="FacebookUsername" ref={control => this.facebookControlRef = control} className="mdl-textfield__input focustip" value={this.props.currentProfile.FacebookUsername} onChange={this.props.updateProfileField} data-toggle="tooltip" data-placement="top" title="This refers to the username of your Facebook Page, not your personal user profile or login. It is the name that appears after https://www.facebook.com/ when viewing your page. This field is optional" />
                                            <label className="mdl-textfield__label" htmlFor="FacebookUsername">Facebook Page Username</label>
                                        </div>
                                        <div id="divWebsiteUrl" className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-block">
                                            <input type="url" id="WebsiteUrl" name="WebsiteUrl" ref={control => this.websiteControlRef = control} className="mdl-textfield__input focustip" value={this.props.currentProfile.WebsiteUrl} onChange={this.props.updateProfileField} data-toggle="tooltip" data-placement="top" title="Please enter the full url including the http://www part" />
                                            <label className="mdl-textfield__label" htmlFor="CurrentProfile_WebsiteUrl">Website Url</label>
                                        </div>
                                    </React.Fragment>
                                    : null
                            }                            
                        </div>
                    </div>
                </div>
                <p style={{textAlign: 'center'}}>
                    {
                        !this.props.currentProfile.ID ?
                            <React.Fragment>
                                <input type="button" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--dark mdl-button--wide" value="CLEAR" onClick={this.clear} />
                                {" "}
                            </React.Fragment>
                            :
                            null
                    }
                    <input type="submit" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent mdl-button--wide" value={this.props.currentProfile.ID ? 'SAVE' : 'CREATE'} />           
                </p>
            </form>            
        ); 
    }
}

CreateProfileForm.propTypes = {
    displayNarrow: PropTypes.bool,
    instruments: PropTypes.array.isRequired,
    genres: PropTypes.array,
    clear: PropTypes.func,
    onProfileCreated: PropTypes.func,
    currentProfile: PropTypes.object,
    actions: PropTypes.object.isRequired,
    updateProfileField: PropTypes.func.isRequired,
    createProfileError: PropTypes.string,
    updateLocation: PropTypes.func
};


function mapStateToProps(state, ownProps) {
    return { 
        user: state.account.user,
        newSignup: state.account.newSignup,
        genres: state.genres, 
        instruments: state.instruments,
        currentProfile: ownProps.currentProfile ? ownProps.currentProfile : state.account.user.activeProfile,
        createProfileError: state.artists.createProfileError
    };
}

function mapDispatchToProps(dispatch) {
    return {
        //artist actions will now be available under this.props.actions
        actions: bindActionCreators(Object.assign({}, artistAdminActions, instrumentActions, genreActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateProfileForm);